import { render, staticRenderFns } from "./app-host-module.vue?vue&type=template&id=463d4eee&scoped=true"
import script from "./app-host-module.vue?vue&type=script&lang=js"
export * from "./app-host-module.vue?vue&type=script&lang=js"
import style0 from "./app-host-module.vue?vue&type=style&index=0&id=463d4eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463d4eee",
  null
  
)

export default component.exports